var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "basket-list-item py-2 bkr-cc",
      class: "item_" + _vm.basketItem.variation.data.item.id,
    },
    [
      _vm._t("before-basket-item"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "basket-item component-loading with-icon d-flex",
          class: {
            "sending is-loading": _vm.waiting,
            "is-loading": _vm.isCheckoutReadonly,
          },
        },
        [
          _c("div", { staticClass: "image-container" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm._f("itemURL")(_vm.basketItem.variation.data),
                },
              },
              [
                _vm.image
                  ? _c("lazy-img", {
                      attrs: {
                        "picture-class": "d-block mw-100 mh-100",
                        "image-url": _vm.image,
                        alt: _vm.altText,
                        title: _vm.itemName,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "meta-container-wrapper" },
            [
              _c("div", { staticClass: "meta-container-wrapper-inner" }, [
                _c("div", { staticClass: "meta-container d-flex" }, [
                  _c(
                    "div",
                    { staticClass: "position-relative w-100 basket-item-name" },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "item-name text-primary text-appearance small font-weight-bold",
                          attrs: {
                            href: _vm._f("itemURL")(
                              _vm.basketItem.variation.data
                            ),
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("itemName")(
                                  _vm.basketItem.variation.data
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "smallProductInfo" },
                        [
                          _c("div", [
                            _vm.basketItem.variation.data.item.id == 500
                              ? _c("strong", [_vm._v("Preis pro Baum: ")])
                              : _c("strong", [_vm._v("Einzelpreis: ")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm._f("currency")(_vm.unitPrice))),
                            ]),
                          ]),
                          _vm._v(" "),
                          !(
                            _vm.basketItem.variation.data.unit
                              .unitOfMeasurement === "C62" &&
                            _vm.basketItem.variation.data.unit.content === 1
                          ) &&
                          _vm.basketItem.variation.data.variation
                            .mayShowUnitPrice
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-muted small smallContent",
                                },
                                [
                                  _c("div", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.basketContent"
                                          )
                                        ) + ": "
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.basketItem.variation.data.unit
                                            .content
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.basketItem.variation.data.unit
                                            .names.name
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.basePrice) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.basketItem.inputLength > 0 ||
                          _vm.basketItem.inputWidth > 0
                            ? _c("div", { staticClass: "small smallUnit" }, [
                                _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemInput"
                                        )
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm._f("inputUnit")(
                                            _vm.basketItem,
                                            true
                                          )
                                        ) +
                                        ": "
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("inputUnit")(_vm.basketItem)
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.basketItem.variation.data.item.id == 500 &&
                          _vm.showMoreInformation
                            ? _c("div", { staticClass: "small smallUnit" }, [
                                _c("strong", [_vm._v("Wir sagen danke!")]),
                                _vm._v(
                                  " Mit Ihrer Unterstützung pflanzen wir gemeinsam mit\n                                HessenForst einen Baum im Taunus. Dieser bindet im Schnitt 12,5 kg CO"
                                ),
                                _c("sub", [_vm._v("2")]),
                                _vm._v(
                                  "\n                                pro Jahr.\n                            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showMoreInformation
                            ? _c(
                                "div",
                                { staticClass: "small smallAttr" },
                                _vm._l(_vm.attributes, function (attribute) {
                                  return _c(
                                    "div",
                                    { staticClass: "attrAttr" },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(attribute.name) + ": "),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(attribute.value.names.name)
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showMoreInformation
                            ? _c("order-property-value-list", {
                                attrs: { "basket-item": _vm.basketItem },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isMoreButtonVisible
                            ? _c("div", {
                                staticClass: "showDetails",
                                class: { collapsed: !_vm.showMoreInformation },
                                attrs: {
                                  "data-show-more": "Details anzeigen",
                                  "data-show-less": "Details ausblenden",
                                  "aria-label": _vm.$translate(
                                    "Ceres::Template.basketShowMore"
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showMoreInformation =
                                      !_vm.showMoreInformation
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "basket-item-container-right" }, [
                    _c(
                      "div",
                      { staticClass: "qty-box-container" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn text-danger-darker p-0 mr-2",
                            class: {
                              disabled:
                                _vm.waiting ||
                                _vm.isBasketLoading ||
                                _vm.isCheckoutReadonly ||
                                _vm.waitingForDelete,
                            },
                            attrs: {
                              title: _vm.$translate(
                                "Ceres::Template.basketDelete"
                              ),
                            },
                            on: { click: _vm.deleteItem },
                          },
                          [
                            _c("icon", {
                              staticClass: "default-float",
                              attrs: {
                                icon: "trash-o",
                                loading: _vm.waitingForDelete,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("quantity-input", {
                          attrs: {
                            "use-appearance": true,
                            value: _vm.basketItem.quantity,
                            waiting:
                              _vm.isInputLocked || _vm.isCheckoutReadonly,
                            min: _vm.basketItem.variation.data.variation
                              .minimumOrderQuantity,
                            max: _vm.basketItem.variation.data.variation
                              .maximumOrderQuantity,
                            interval:
                              _vm.basketItem.variation.data.variation
                                .intervalOrderQuantity,
                          },
                          on: { "quantity-change": _vm.updateQuantity },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "font-weight-bold my-2 text-right prices",
                        class: { crossPrice: _vm.hasCrossPrice },
                      },
                      [
                        _vm.hasCrossPrice
                          ? _c("del", { staticClass: "crossprice" }, [
                              _vm._v(
                                "\n                                statt " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.basketItem.quantity *
                                        _vm.basketItem.variation.data.prices.rrp
                                          .price.value,
                                      _vm.basketItem.variation.data.prices
                                        .default.currency
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.basketItem.quantity * _vm.unitPrice,
                                _vm.basketItem.variation.data.prices.default
                                  .currency
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.basketItem.setComponents
                ? _c("basket-set-component-list", {
                    attrs: {
                      "set-components": _vm.basketItem.setComponents,
                      "set-item": _vm.basketItem,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm._t("after-basket-item"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }